module.exports = __webpack_public_path__ + "static/img/6449_phase_function_Paper_Points.5becc89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6449_phase_function_Paper_Points.png
// module id = H99Q
// module chunks = 0